export default "__VITE_ASSET__B3gthN4K__"